import React, { useState } from 'react';
import config from '../../config';
import { Box, Button, Text, VStack } from '@chakra-ui/react';

const TestConnection = () => {
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const testConnection = async () => {
    try {
      console.log('Testing connection to server...');
      const response = await fetch(`${config.apiUrl}/health`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      });

      console.log('Response:', response);
      console.log('Response status:', response.status);
      console.log('Response headers:', Object.fromEntries(response.headers));

      const text = await response.text();
      console.log('Response text:', text);

      try {
        const data = JSON.parse(text);
        setStatus(`Server response: ${data.message}`);
        setError('');
      } catch (e) {
        setError('Failed to parse server response');
      }
    } catch (error) {
      console.error('Error:', error);
      setError(`Connection error: ${error.message}`);
    }
  };

  return (
    <Box p={4}>
      <VStack spacing={4}>
        <Button onClick={testConnection}>Test Server Connection</Button>
        {status && <Text color='green.500'>{status}</Text>}
        {error && <Text color='red.500'>{error}</Text>}
      </VStack>
    </Box>
  );
};

export default TestConnection;
